import { addCommas, removeCommas } from "@persian-tools/persian-tools";
// import {checkMore} from "./Financialtabs"
// datepicker
import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
import { useState } from "react";
import Select from "react-select";
export default function Orders({
  indexId,
  numberOfOrder,
  numberOfItems,
  dateOfOrder,
  totalPrice,
  paidPrice,
  discountPrice,
  setSelected,
  value,
  userOrder,
  defaultOrder,
}) {
  userOrder.map((value, index) => {
    return {
      // label: "",
      // value: index,
      data: value,
    };
  });

  // const [orderId, setOrderId] = useState();

  console.log("defaultOrder", defaultOrder, userOrder);
  return (
    <>
      <Select
        className="w-100 mt-3"
        options={userOrder}
        onChange={(value) => {
          setSelected(value.data);
        }}
      />
    </>
  );
}
